import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-session-error',
  templateUrl: './session-error.component.html',
  styleUrls: ['./session-error.component.less']
})
export class SessionErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
